import { useContext } from 'react';
import AuthContext from '../context/AuthContext';
import { AddToCart, CartDelete } from "../api/cartService";

const useCartHandler = () => {
    const { user } = useContext(AuthContext);
    const HandleCartInsert = async ({ request, fetchData }) => {
        if (!user?.SelectedCustomer_ID || user?.SelectedCustomer_ID === 0) {
            return {
                success: false,
                message: "Please select a specific customer to add items to cart.",
                type: "warning"
            };
        }
        if (!request || Object.keys(request).length === 0) {
            return {
                success: false,
                message: "Invalid request parameters!"
            };
        }
        const { Style_ID, Quantity, JewelCode, StyleNo, Rate, } = request;

        const cartParams = {
            Party_ID: user?.SelectedCustomer_ID || "0",
            Style_ID: Style_ID,
            JewelCode: JewelCode,
            StyleNo: StyleNo,
            Quantity: Quantity,
            OrderCategory: "ORDER",
            Rate: Rate || "0",
        };

        try {
            const cartData = await AddToCart(cartParams);
            const messages = cartData?.Message || cartData?.ZMESSAGE;

            if (messages && Array.isArray(messages) && messages.length > 0) {
                const returnCode = messages[0]?.RETURNCODE;
                const returnMessage = messages[0]?.RETURNMESSAGE || "Item Added To Cart!";
                const returnMessageTitle = messages[0]?.RETURNMESSAGETITLE || "Successful!";

                const lastIndex = (cartData.ROW?.length || 0) - 1;
                let newBasketID = "";
                if (lastIndex >= 0) {
                    newBasketID = cartData.ROW[lastIndex]?.Basket_ID;
                }

                switch (returnCode) {
                    case "1":
                        if (fetchData) fetchData();
                        return {
                            success: true,
                            message: returnMessage,
                            titleMessage: returnMessageTitle,
                            newBasketID: newBasketID,
                        };
                    case "0":
                        return {
                            success: false,
                            message: returnMessage,
                            type: "warning",
                        };
                    case "-1":
                        return {
                            success: false,
                            message: returnMessage,
                            type: "error",
                        };
                    default:
                        return {
                            success: false,
                            message: returnMessage || "Something Went Wrong. Please try again later.",
                        };
                }
            } else {
                return {
                    success: false,
                    message: "Failed to add item to cart. Response is empty or invalid.",
                };
            }
        } catch (error) {
            return {
                success: false,
                message: `An error occurred while adding the item: ${error.message || error}`,
            };
        }
    };

    const HandleCartRemove = async ({ Cart_ID, Style_ID, fetchData }) => {
        const requestParameter = {
            Party_ID: user?.SelectedCustomer_ID || "0",
            Cart_ID: String(Cart_ID),
            Style_ID: Style_ID,
        };

        try {
            const cartData = await CartDelete(requestParameter);
            const messages = cartData?.Message || cartData?.ZMESSAGE;

            if (messages && Array.isArray(messages) && messages.length > 0) {
                const returnCode = messages[0]?.RETURNCODE;
                const returnMessage = messages[0]?.RETURNMESSAGE || "Item Removed From Cart!";
                const returnMessageTitle = messages[0]?.RETURNMESSAGETITLE || "Successful!";

                switch (returnCode) {
                    case "1":
                        if (fetchData) fetchData();
                        return {
                            success: true,
                            message: returnMessage,
                            titleMessage: returnMessageTitle,
                        };
                    case "0":
                        return {
                            success: false,
                            message: returnMessage,
                            type: "warning",
                        };
                    case "-1":
                        return {
                            success: false,
                            message: returnMessage,
                            type: "error",
                        };
                    default:
                        return {
                            success: false,
                            message: returnMessage || "Something Went Wrong. Please try again later.",
                        };
                }
            } else {
                return {
                    success: false,
                    message: "Failed to remove from Cart. Response is empty or invalid.",
                };
            }
        } catch (error) {
            return {
                success: false,
                message: `An error occurred while removing the item: ${error.message || error}`,
            };
        }
    };
    return { HandleCartInsert, HandleCartRemove };
};
export default useCartHandler;

